import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import BiodieselFormulas from '../containers/BiodieselFormulas';
import GasFormulas from '../containers/GasFormulas';
import RackFormulas from '../containers/RackFormulas';
import StationContainer from '../containers/Station';
import QuickbooksContainer from '../containers/accounting/Quickbooks';
import { validateEmail } from '../libs/utility';
import FMPTextField from '../components/ui/FMPTextField';
import FMPHeadline from '../components/ui/FMPHeadline';
import FMPRegionHeader from '../components/ui/FMPRegionHeader';
import AuthUserContainer from '../containers/AuthUser';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FMPSelect from '../components/form/FMPSelect';
import PureFMPSelect from '../components/pureForm/FMPSelect';
import FMPPaymentOptionSelect from '../components/pureForm/FMPPaymentOptionSelect';
import FMPSwitch from '../components/pureForm/FMPSwitch';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

import { stationTankProducts } from '../libs/products';
import FMPSectionHeader from '../components/ui/FMPSectionHeader';
import FMPText from '../components/pureForm/FMPText';
import FMPCheckbox from '../components/pureForm/FMPCheckbox';
import FMPSubmitButton from '../components/form/FMPSubmitButton';
import FMPStationRegionPicker from '../components/pureForm/FMPStationRegionPicker';
import FMPStationOwnershipGroupPicker from '../components/pureForm/FMPStationOwnershipGroupPicker';
import FMPCarrierSelect from '../components/pureForm/FMPCarrierSelect';
import Note from '../components/ui/Note';
import FMPDatePicker from '../components/pureForm/FMPDatePicker';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { post } from '../modules/utility';
import { showErrors } from '../modules/general';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		warningIcon: {
			marginTop: -9,
			width: 26,
			height: 26,
			position: 'relative',
			bottom: -7,
			marginRight: 3,
			color: '#F4511E',
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 10,
			marginBottom: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 5,
			marginBottom: 10,
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 32,
			height: 32,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
	};
};

//const isLocalhost = Boolean(window.location.hostname === 'localhost');
//const baseUrl = !isLocalhost ? 'https://fmp.pearsonfuels.com' : 'http://localhost:3001';

const formFields = {
	deliveryEmails: [''],
	invoiceEmails: [''],
};

class SaveStation extends Component {
	constructor(props) {
		super(props);
		const updateId = _.get(this.props, ['match', 'params', 'stationId']);

		this.state = {
			updateId: updateId ? parseInt(updateId, 10) : undefined,
			isUpdate: updateId,
			deliveryEmails: [],
			invoiceEmails: [],
			invoiceQuickbooksCustomerId: '',
			formFieldError: {},
			tanks: [],
			open: true,
			number: '',
			name: '',
			contactName: '',
			contactPhoneNumber: '',
			contactEmail: '',
			contactManagerName: '',
			contactManagerPhoneNumber: '',
			contactManagerEmail: '',
			address: '',
			addressOld: '',
			addressLine1: '',
			addressLine2: '',
			city: '',
			state: 'CA',
			zip: '',
			deliveryAddressNotes: '',

			requireUnlPriceOnInvoicing: false,
			freightFullLoad: '',
			//freightHalfLoadSplit: '',
			//freightHalfLoadNoSplit: '',
			pinnacleDeliveryAdder: '',
			rackFormulaId: '',
			gasFormulaId: '',
			primaryCarrierId: '',
			biodieselFormulaId: '',
			opisLocationId: '',
			stationHasCarWash: false,
			stationIsNotPublic: false,
			stationIsNotActive: false,
			stationIsOnCreditHold: false,
			smsPricingIsDisabled: false,
			creditHoldStartDate: null,
			deliveryNotes: '',
			paymentOptions: [],
			smsMessages: {
				singleSiteMessages: [],
				multiSiteMessages: [],
			},
			smsMessagesLoading: false,
			smsMessagesError: null,
		};
	}

	updateDefaultValues(props) {
		if (props.station) {
			const {
				number,
				name,
				contactName,
				contactPhoneNumber,
				contactEmail,
				contactManagerName,
				contactManagerPhoneNumber,
				contactManagerEmail,
				addressOld,
				addressLine1,
				addressLine2,
				city,
				state,
				zip,
				deliveryAddressNotes,

				gasFormulaId,
				primaryCarrierId,
				rackFormulaId,
				biodieselFormulaId,
				freightFullLoad,
				//freightHalfLoadSplit,
				//freightHalfLoadNoSplit,
				pinnacleDeliveryAdder,
				tanks,
				opisLocationId,
				deliveryEmails,
				invoiceEmails,
				invoiceQuickbooksCustomerId,
				requireUnlPriceOnInvoicing,
				publicName,
				longitude,
				latitude,
				hoursOfOperation,
				brand,
				stationHasCarWash,
				preferredDeliveryAmount,
				paymentOptions,
				openOrComingSoon,
				openedDate,
				publicPhoneNumber,
				deliveryNotes,
				invoiceNotes,
				stationIsNotPublic,
				stationIsNotActive,
				smsPricingIsDisabled,
				creditHoldStartDate,
				region,
				ownershipGroup,
				lastUpdatedAt,
				lastUpdatedBy,
				mobileNumberForSmsPricing,
				mobileNumberRecipient,
				salesTax,
			} = props.station;

			const stationIsOnCreditHold = creditHoldStartDate ? true : false;

			this.setState({
				number,
				name,
				contactName,
				contactPhoneNumber,
				contactEmail,
				contactManagerName,
				contactManagerPhoneNumber,
				contactManagerEmail,
				addressOld,
				addressLine1,
				addressLine2,
				city,
				state: state || 'CA',
				zip,
				deliveryAddressNotes,
				gasFormulaId,
				primaryCarrierId,
				rackFormulaId,
				biodieselFormulaId,
				freightFullLoad,
				//freightHalfLoadSplit,
				//freightHalfLoadNoSplit,
				pinnacleDeliveryAdder,
				tanks,
				opisLocationId,
				deliveryEmails,
				invoiceEmails,
				invoiceQuickbooksCustomerId,
				requireUnlPriceOnInvoicing,
				publicName,
				longitude,
				latitude,
				hoursOfOperation,
				brand,
				stationHasCarWash,
				preferredDeliveryAmount,
				paymentOptions,
				openOrComingSoon,
				openedDate,
				publicPhoneNumber,
				deliveryNotes,
				invoiceNotes,
				stationIsNotPublic,
				stationIsNotActive,
				smsPricingIsDisabled,
				stationIsOnCreditHold,
				creditHoldStartDate,
				region,
				ownershipGroup,
				lastUpdatedAt,
				lastUpdatedBy,
				mobileNumberForSmsPricing,
				salesTax,
				mobileNumberRecipient,
			});
		}
	}

	componentDidMount() {
		const { isExternalLogistics, quickbooksCustomers, searchQuickbooksCustomers } = this.props;

		if (!isExternalLogistics) {
			if (!this.props.gasFormulas.length) {
				this.props.searchGasFormulas();
			}

			if (!this.props.rackFormulas.length) {
				this.props.searchRackFormulas();
			}
			if (!this.props.biodieselFormulas.length) {
				this.props.searchBiodieselFormulas();
			}

			if (_.isEmpty(quickbooksCustomers)) {
				searchQuickbooksCustomers();
			}
		}

		if (this.state.isUpdate) {
			if (!this.props.station) {
				this.props.getStation({
					params: {
						stationIds: [this.state.updateId],
					},
				});
			} else {
				this.updateDefaultValues(this.props);
			}
		} else {
			this.updateDefaultValues(this.props);
		}

		// Fetch SMS messages from backend
		this.fetchSmsMessages();
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.station) && this.props.station) {
			this.updateDefaultValues(this.props);
		}
	}

	fetchSmsMessages = async () => {
		this.setState({ smsMessagesLoading: true, smsMessagesError: null });

		post({
			method: 'pricingRequest.getReplyMessages',
			params: {
				stationId: this.state.updateId,
			},

			callback: (err, smsMessage) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({
					smsMessages: smsMessage,
					smsMessagesLoading: false,
				});
			},
		});
	};

	onAddUpdateStation = () => {
		const { showErrors, gasFormulas } = this.props;

		const params = {};
		[
			'number',
			'name',
			'contactName',
			'contactPhoneNumber',
			'contactEmail',
			'contactManagerName',
			'contactManagerPhoneNumber',
			'contactManagerEmail',
			//'address',
			//'addressOld',
			'addressLine1',
			'addressLine2',
			'city',
			'state',
			'zip',
			'deliveryAddressNotes',
			//'gasFormulaId', 'rackFormulaId', 'biodieselFormulaId',
			'opisLocationId',
			'deliveryEmails',
			'invoiceEmails',
			'invoiceQuickbooksCustomerId',
			'requireUnlPriceOnInvoicing',

			'publicName',
			'hoursOfOperation',
			'brand',
			'openOrComingSoon',
			'openedDate',
			'publicPhoneNumber',
			'deliveryNotes',
			'invoiceNotes',
			'paymentOptions',
			'stationHasCarWash',
			'stationIsNotPublic',
			'stationIsNotActive',
			'smsPricingIsDisabled',
			'lastUpdatedAt',
			'ownershipGroup',
			'region',
			'mobileNumberRecipient',
			'creditHoldStartDate',
		].forEach((fieldName) => {
			params[fieldName] = this.state[fieldName];
		});

		[
			'freightFullLoad',
			//'freightHalfLoadSplit',
			//'freightHalfLoadNoSplit',
			'pinnacleDeliveryAdder',
		].forEach((fieldName) => {
			params[fieldName] = parseFloat(this.state[fieldName] || 0);
		});

		if (params.freightFullLoad) {
			params.freightHalfLoadSplit = params.freightFullLoad;
			params.freightHalfLoadNoSplit = params.freightFullLoad;
		}

		if (this.state.primaryCarrierId) {
			params.primaryCarrierId = this.state.primaryCarrierId;
		}

		['preferredDeliveryAmount'].forEach((fieldName) => {
			let val = this.state[fieldName];
			if (val === null || val === '' || val === '0') {
				params[fieldName] = 0;
				return;
			}
			if (_.isString(val)) {
				val = parseInt(val.replace(/,/g, ''), 10);
			}

			params[fieldName] = val;
		});

		['gasFormulaId', 'rackFormulaId', 'biodieselFormulaId'].forEach((fieldName) => {
			params[fieldName] = this.state[fieldName] || 0;
		});

		const formFieldError = {};
		const {
			longitude,
			latitude,
			tanks,
			mobileNumberRecipient,
			salesTax,
			openOrComingSoon,
			openedDate,
			stationIsOnCreditHold,
			creditHoldStartDate,
		} = this.state;

		if (params.creditHoldStartDate) {
			params.creditHoldStartDate = moment(creditHoldStartDate).format('YYYY-MM-DD');
		}

		let { mobileNumberForSmsPricing } = this.state;
		// clean up the number
		if (mobileNumberForSmsPricing) {
			mobileNumberForSmsPricing = mobileNumberForSmsPricing.replace(/[-.]/g, '');
		}

		if (stationIsOnCreditHold && !creditHoldStartDate) {
			formFieldError.creditHoldStartDate =
				'If a station is on CREDIT HOLD it needs a credit on hold start date';
		}

		if (openOrComingSoon === 'comingSoon' && openedDate) {
			formFieldError.comingSoon = 'Station should not be Coming Soon and have an Date Opened';
		}

		params.tanks = tanks;

		if (longitude && latitude) {
			if (!parseFloat(longitude)) {
				formFieldError.longitude = 'Longitude must be a float +/- 180.';
			}

			if (!parseFloat(latitude)) {
				formFieldError.latitude = 'Latitude must be a float +/- 90.';
			}

			params.location = {
				longitude: parseFloat(longitude),
				latitude: parseFloat(latitude),
			};
		}

		if (salesTax) {
			if (!parseFloat(salesTax) || salesTax > 0.2) {
				formFieldError.salesTax =
					'Sales tax must be a decimal (eg 0.0925) and should be lower that .2';
			} else {
				params.salesTax = parseFloat(salesTax);
			}
		}

		if (mobileNumberForSmsPricing || mobileNumberRecipient) {
			if (!mobileNumberForSmsPricing) {
				formFieldError.mobileNumberForSmsPricing =
					'Mobile number, recipient and greeting are ALL required.';
			}
			if (!mobileNumberRecipient) {
				formFieldError.mobileNumberRecipient =
					'Mobile number, recipient and greeting are ALL required.';
			}
		}

		if (mobileNumberForSmsPricing && !mobileNumberForSmsPricing.match(/^[0-9]{10}$/)) {
			formFieldError.mobileNumberForSmsPricing =
				'Mobile number number should only contain 10 digits.';
		}
		params.mobileNumberForSmsPricing = mobileNumberForSmsPricing;

		let { contactEmail, contactManagerEmail } = this.state;
		if (contactEmail) {
			if (!validateEmail(contactEmail)) {
				formFieldError.contactEmail = 'Invalid characters in owner email';
			}
		}
		if (contactManagerEmail) {
			if (!validateEmail(contactManagerEmail)) {
				formFieldError.contactManagerEmail = 'Invalid characters in manager email';
			}
		}

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		//
		//- Client side validation
		//

		const gasFormula = _.find(gasFormulas, { gasFormulaId: params.gasFormulaId });
		if (gasFormula) {
			/** @typedef string gasFormula.formulaKey **/
			if (
				gasFormula.formulaKey === 'pinnaclePricing' ||
				gasFormula.formulaKey === 'pinnaclePricingNonContracted'
			) {
				if (_.isNil(params.pinnacleDeliveryAdder)) {
					return showErrors(['Pinnacle delivery adder required']);
				}
			}
		}

		const errors = [];
		params.tanks.forEach((tank) => {
			['totalTankVolume', 'shutoffVolume', 'resupplyVolume', 'tankNumber'].forEach((s) => {
				let val = tank[s];
				if (!val) {
					return;
				}

				tank[s] = val = parseInt(val, 10);

				if (!_.isFinite(val)) {
					return errors.push([`${s} must be an integer`]);
				}
			});
		});

		if (errors.length) {
			return showErrors(errors);
		}

		//- Required fields
		[
			{ fieldName: 'name', display: 'Name' },
			//{fieldName: 'publicName', display: 'Public Name'},
			{ fieldName: 'openOrComingSoon', display: 'Open or Coming Soon' },
			{ fieldName: 'region', display: 'Region' },
			{ fieldName: 'ownershipGroup', display: 'Ownership Group' },
		].forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		params.deliveryEmails.forEach((email, i) => {
			if (validateEmail(email)) {
				return;
			}
			_.set(formFieldError, ['deliveryEmails', i], 'Invalid characters in email');
		});

		params.invoiceEmails.forEach((email, i) => {
			if (validateEmail(email)) {
				return;
			}
			_.set(formFieldError, ['invoiceEmails', i], 'Invalid characters in email');
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		if (this.state.isUpdate) {
			params.stationId = this.state.updateId;
			this.props.updateStation({ params });
		} else {
			this.props.addStation({ params });
		}
	};

	onChangeName = (e, fieldName) => {
		this.setState({ [fieldName]: e.target.value });
	};

	handleSelectChange = (event, fieldName) => {
		this.setState({ [fieldName]: event.target.value });
	};

	onSwitchChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		this.setState(newState);
	};

	onChange(event, fieldName, index, attr) {
		if (!_.isNumber(index)) {
			const newState = { [fieldName]: event.target.value };

			this.setState(newState);
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}

			this.setState({ [fieldName]: inputs });
		}
	}

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	onChangeTank = (e, i, attr) => {
		/** @namespace this.state.tanks **/
		const tanks = this.state.tanks.slice();
		tanks[i][attr] = e.target.value;
		this.setState({ tanks });
	};

	addTank = () => {
		const tanks = this.state.tanks;
		tanks.push({
			productType: 'e85',
			tankNumber: '',
			totalTankVolume: '',
			shutoffVolume: '',
			resupplyVolume: '',
			tankType: 'Gravity Drop',
		});
		this.setState({ tanks });
	};

	removeTank = (index) => {
		/** @namespace this.state.tanks **/
		const tanks = this.state.tanks.slice();
		tanks.splice(index, 1);
		this.setState({ tanks });
	};

	onPureChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), val);
				newState[basePath] = base;
			} else {
				newState[basePath] = val;
			}
		} else {
			newState[basePath] = val;
		}

		if (path === 'stationIsOnCreditHold') {
			console.log('event.target.value', value);
			if (!value) {
				newState.creditHoldStartDate = null;
			}
		}
		this.setState(newState);
	};

	getInputProps = (path, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onPureChange,
			checked: this.getValue(path, false),
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	renderFormatAddress = () => {
		let { addressLine1, addressLine2, city, state, zip, deliveryAddressNotes } = this.state;
		if (!city || !state || !zip || !addressLine1) {
			return `AddressLine1 / City / State / Zip required`;
		}

		// Construct the base address
		let addressLine = addressLine1;

		if (addressLine2) {
			addressLine += ` ${addressLine2}`;
		}

		addressLine += `, ${city}, ${state} ${zip}`;

		if (deliveryAddressNotes) {
			addressLine += ` (${deliveryAddressNotes})`;
		}
		return addressLine;
	};

	render() {
		const {
			classes,
			station,
			gasFormulas,
			rackFormulas,
			biodieselFormulas,
			isExternalLogistics,
			userMap,
		} = this.props;
		const { isUpdate } = this.state;

		if (!isExternalLogistics) {
			if (!gasFormulas.length || !rackFormulas.length || !biodieselFormulas.length) {
				return <div>Fetching formulas...</div>;
			}
		}

		if (isUpdate && !station) {
			return <div>Fetching station details...</div>;
		}

		let action = isUpdate ? 'Update Station' : 'Add Station';
		if (isExternalLogistics) {
			action = 'View Station Details';
		}

		let lastUpdatedByName;
		let lastUpdatedDisplay;
		if (this.state.lastUpdatedBy) {
			lastUpdatedByName = _.get(userMap[this.state.lastUpdatedBy], 'firstName');
			lastUpdatedDisplay = moment(this.state.lastUpdatedAt).format('ddd, M/D/YY h:mm a');
		}
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label={action} />

					<Paper className={classes.paper}>
						<FMPRegionHeader isTop={true} label={'Station Info'} />

						{this.state.stationIsOnCreditHold && (
							<Note type="warn">
								<WarningIcon className={classes.warningIcon} />
								This station is currently on a CREDIT HOLD. Any new deliveries should be cleared
								with accounting.
							</Note>
						)}

						<FMPSectionHeader label={'Internal Information (Pearson & partners only)'} />

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.number}
								onChange={(event) => this.onChangeName(event, 'number')}
								label="Station number"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.name}
								onChange={(event) => this.onChangeName(event, 'name')}
								label="Station name"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.opisLocationId}
								onChange={(event) => this.onChangeName(event, 'opisLocationId')}
								label="OPIS Location Id"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<FMPStationRegionPicker {...this.getInputProps(`region`)} md={12} />
						</Grid>

						<Grid item xs={12} md={6}>
							<FMPStationOwnershipGroupPicker {...this.getInputProps(`ownershipGroup`)} md={12} />
						</Grid>

						{!isExternalLogistics && (
							<Grid item xs={12} md={6}>
								<FMPCarrierSelect
									{...this.getInputProps(`primaryCarrierId`)}
									label="Primary Carrier"
									md={12}
									helpText="Controls which resources an external logistics users can see"
								/>
							</Grid>
						)}

						<FMPCheckbox
							{...this.getInputProps('stationIsNotActive')}
							label={
								'Station is not active. Will not be included in monitoring, inventory, SMS price notifications, and sales.'
							}
							value={'stationIsNotActive'}
							md={12}
						/>

						<FMPCheckbox
							{...this.getInputProps('stationIsOnCreditHold')}
							label={'Station is on CREDIT HOLD. Will be flagged to not be delivered too.'}
							value={'stationIsNotActive'}
							md={12}
						/>

						<div style={{ opacity: this.state.stationIsOnCreditHold ? 1 : 0.5 }}>
							<FMPDatePicker
								{...this.getInputProps('creditHoldStartDate')}
								label={'Date Credit Hold Started'}
								format={'MMMM Do, YYYY'}
								md={6}
								showClearButton={true}
							/>
						</div>

						<FMPSectionHeader label={'Address Information'} />

						<Grid item xs={12} md={6}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={12}>
									<TextField
										//className={classes.formControl}
										value={this.state.addressOld}
										//onChange={(event) => this.onChangeName(event, 'address')}
										label="(OLD) Station address"
										fullWidth
										disabled="true"
									/>
								</Grid>

								<Grid item xs={12} md={12}>
									<TextField
										//className={classes.formControl}
										value={this.state.addressLine1}
										onChange={(event) => this.onChangeName(event, 'addressLine1')}
										label="Address Line 1"
										fullWidth
									/>
								</Grid>
								<Grid item xs={12} md={12}>
									<TextField
										//className={classes.formControl}
										value={this.state.addressLine2}
										onChange={(event) => this.onChangeName(event, 'addressLine2')}
										label="Address Line 2 (apt, suite, building, gate, etc)"
										fullWidth
									/>
								</Grid>

								<Grid item xs={12} md={6}>
									<TextField
										//className={classes.formControl}
										value={this.state.city}
										onChange={(event) => this.onChangeName(event, 'city')}
										label="City"
										fullWidth
									/>
								</Grid>
								<Grid item xs={12} md={2}>
									<TextField
										//className={classes.formControl}
										value={this.state.state || 'CA'}
										onChange={(event) => this.onChangeName(event, 'state')}
										label="State"
										fullWidth
										disabled="true"
									/>
								</Grid>
								<Grid item xs={12} md={4}>
									<TextField
										//className={classes.formControl}
										value={this.state.zip}
										onChange={(event) => this.onChangeName(event, 'zip')}
										label="ZIP Code"
										fullWidth
									/>
								</Grid>

								<Grid item xs={12} md={12}>
									<TextField
										//className={classes.formControl}
										value={this.state.deliveryAddressNotes}
										onChange={(event) => this.onChangeName(event, 'deliveryAddressNotes')}
										label="Delivery notes (only included on carrier emails)"
										fullWidth
									/>
								</Grid>
								<Grid item xs={12} md={12}>
									<div style={{ fontSize: '12px', textTransform: 'uppercase', fontWeight: '600' }}>
										Address Example display
									</div>
									<div
										style={{
											padding: '10px',
											backgroundColor: '#f7f7f7',
											border: '1px solid #eee',
										}}
									>
										{this.renderFormatAddress()}
									</div>
								</Grid>
							</Grid>
						</Grid>

						<FMPSectionHeader label={'Owner Contact Information'} />
						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactName}
								onChange={(event) => this.onChangeName(event, 'contactName')}
								label="Owner contact name"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactPhoneNumber}
								onChange={(event) => this.onChangeName(event, 'contactPhoneNumber')}
								label="Owner contact phone number"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactEmail}
								onChange={(event) => this.onChangeName(event, 'contactEmail')}
								label="Owner contact email address"
								fullWidth
							/>
						</Grid>

						<FMPSectionHeader label={'Manager Contact Information'} />
						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactManagerName}
								onChange={(event) => this.onChangeName(event, 'contactManagerName')}
								label="Manager contact name"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactManagerPhoneNumber}
								onChange={(event) => this.onChangeName(event, 'contactManagerPhoneNumber')}
								label="Manager contact phone number"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.contactManagerEmail}
								onChange={(event) => this.onChangeName(event, 'contactManagerEmail')}
								label="Manager contact email address"
								fullWidth
							/>
						</Grid>

						<FMPSectionHeader label={'Public Information (App, Website, etc)'} />

						<div style={{ marginTop: 20 }} />
						<FMPCheckbox
							{...this.getInputProps('stationIsNotPublic')}
							label={'Station is not public and should not be listed on the app or website'}
							value={'stationIsNotPublic'}
						/>

						<FMPText {...this.getInputProps('publicName')} label={'Public Name'} />

						<FMPText {...this.getInputProps('publicPhoneNumber')} label={'Public Phone Number'} />

						<Grid container spacing={2}>
							<FMPText
								{...this.getInputProps('longitude')}
								label={'Longitude'}
								contained={false}
								md={3}
							/>
							<FMPText
								{...this.getInputProps('latitude')}
								label={'Latitude'}
								contained={false}
								md={3}
							/>
						</Grid>

						<FMPText
							{...this.getInputProps('brand')}
							label={'Brand'}
							helpText={'Chevron, Shell, Mobile,...'}
						/>

						<FMPText
							{...this.getInputProps('hoursOfOperation')}
							label={'Hours of operation'}
							helpText={'Eg : "Open 24 hours", "5a-11p M-F, 6a-11p Sat-Sun"'}
						/>

						<FMPPaymentOptionSelect
							{...this.getInputProps('paymentOptions', [])}
							label={'Payment options'}
							helpText={'Select all that apply'}
						/>

						<FMPCheckbox
							{...this.getInputProps('stationHasCarWash')}
							label={'Station has a car wash'}
							value={'stationHasCarWash'}
						/>

						<FMPSectionHeader label={'Open Status'} />

						<PureFMPSelect
							{...this.getInputProps('openOrComingSoon')}
							label={'Open or Coming Soon'}
							options={[
								{ value: 'open', display: 'Open' },
								{ value: 'comingSoon', display: 'Coming Soon' },
							]}
						/>

						<FMPDatePicker
							{...this.getInputProps('openedDate')}
							label={'Date First Opened'}
							format={'MMMM Do, YYYY'}
							md={6}
							showClearButton={true}
						/>

						<Grid item xs={12}>
							<FMPRegionHeader label={'Retail Pricing'} />
						</Grid>

						<FMPCheckbox
							{...this.getInputProps('smsPricingIsDisabled')}
							label={'Disable SMS pricing requests for this station'}
							value={'smsPricingIsDisabled'}
							md={12}
						/>

						<div style={{ opacity: this.state.smsPricingIsDisabled ? 0.5 : 1 }}>
							<FMPText
								{...this.getInputProps('mobileNumberForSmsPricing')}
								label={'Mobile number to SMS for pricing'}
							/>

							<FMPText
								{...this.getInputProps('mobileNumberRecipient')}
								label={'Full name recipient'}
							/>
						</div>

						{/*
						<FMPText
							{...this.getInputProps('mobileNumberGreeting')}
							label={'Greeting name of recipient'}
							helpText={'Usually just first nam (Dave, Mike, etc)'}
						/>
						*/}

						<Grid item xs={12} style={{ paddingTop: 10 }}>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<div style={{ fontSize: 12, color: '#666', padding: '10px 0px' }}>
										See example SMS messages:
									</div>
								</AccordionSummary>
								<AccordionDetails>
									{this.state.smsMessagesLoading && (
										<div style={{ padding: '20px', textAlign: 'center' }}>
											Loading SMS messages...
										</div>
									)}

									{this.state.smsMessagesError && (
										<div style={{ padding: '20px', color: 'red' }}>
											Error loading SMS messages: {this.state.smsMessagesError}
										</div>
									)}

									{!this.state.smsMessagesLoading && !this.state.smsMessagesError && (
										<div style={{ width: '100%' }}>
											<Grid container spacing={2}>
												<Grid item xs={6}>
													<div style={{ marginBottom: '20px' }}>
														<h4
															style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: 'bold' }}
														>
															Single Site Messages (
															{this.state.smsMessages.singleSiteMessages.length})
														</h4>
														{this.state.smsMessages.singleSiteMessages.length === 0 ? (
															<div style={{ fontStyle: 'italic', color: '#666' }}>
																No single site messages available
															</div>
														) : (
															this.state.smsMessages.singleSiteMessages.map((messageObj, index) => (
																<div key={index} style={{ marginBottom: '15px' }}>
																	<div
																		style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}
																	>
																		Message {index + 1} (Days old: {messageObj.daysOld})
																	</div>
																	<div
																		style={{
																			lineHeight: 1.4,
																			backgroundColor: '#438AF6',
																			borderRadius: 10,
																			padding: 14,
																			color: 'white',
																			whiteSpace: 'pre-line',
																			marginRight: '5px',
																		}}
																	>
																		{messageObj.message}
																	</div>
																</div>
															))
														)}
													</div>
												</Grid>
												<Grid item xs={6}>
													<div>
														<h4
															style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: 'bold' }}
														>
															Multi Site Messages ({this.state.smsMessages.multiSiteMessages.length}
															)
														</h4>
														{this.state.smsMessages.multiSiteMessages.length === 0 ? (
															<div style={{ fontStyle: 'italic', color: '#666' }}>
																No multi site messages available
															</div>
														) : (
															this.state.smsMessages.multiSiteMessages.map((messageObj, index) => (
																<div key={index} style={{ marginBottom: '15px' }}>
																	<div
																		style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}
																	>
																		Message {index + 1} (Days old: {messageObj.daysOld})
																	</div>
																	<div
																		style={{
																			lineHeight: 1.4,
																			backgroundColor: '#438AF6',
																			borderRadius: 10,
																			padding: 14,
																			color: 'white',
																			whiteSpace: 'pre-line',
																			marginRight: '5px',
																		}}
																	>
																		{messageObj.message}
																	</div>
																</div>
															))
														)}
													</div>
												</Grid>
											</Grid>
										</div>
									)}
								</AccordionDetails>
							</Accordion>
						</Grid>

						{!isExternalLogistics && this.renderPricingAndCosts()}

						<Grid item xs={12}>
							<FMPRegionHeader label={'Delivery Info'} />
						</Grid>
						{!isExternalLogistics && (
							<>
								<div className={classes.sectionHeader}>Delivery Emails</div>
								{this.state.deliveryEmails.map((email, i) => {
									return (
										<Grid key={i} container spacing={3}>
											<FMPTextField
												name={'deliveryEmails'}
												index={i}
												label={`Email ${i + 1}`}
												controller={this}
												md={5}
												contained={false}
											/>
											<Grid item xs={1}>
												<IconButton
													color="primary"
													className={classes.button}
													onClick={() => this.removeInput('deliveryEmails', i)}
												>
													<DeleteIcon />
												</IconButton>
											</Grid>
										</Grid>
									);
								})}

								<Grid item xs={12}>
									<Button
										variant="contained"
										className={classes.addInputButton}
										onClick={() => this.addInput('deliveryEmails')}
									>
										ADD DELIVERY EMAIL
									</Button>
								</Grid>
							</>
						)}

						<Grid item xs={12}>
							<div className={classes.sectionHeader}>Tank Information</div>
						</Grid>
						<Grid item xs={12}>
							{this.state.tanks.map((tank, i) => {
								return (
									<Grid key={i} container spacing={3} className={classes.inputGroup}>
										<Grid item xs={12} md={2}>
											<Select
												className={classes.formControl}
												style={{ margin: '16px 0px' }}
												value={tank.productType}
												onChange={(event) => this.onChangeTank(event, i, 'productType')}
												input={<Input id={`tank${i}_productType`} />}
											>
												{stationTankProducts.map((item, i) => {
													return (
														<MenuItem key={i} value={item.value}>
															{item.display}
														</MenuItem>
													);
												})}
											</Select>
										</Grid>
										<Grid item xs={12} md={1}>
											<TextField
												style={{ marginTop: 0, marginBottom: 0 }}
												value={tank.tankNumber}
												onChange={(event) => this.onChangeTank(event, i, 'tankNumber')}
												label="Tank #"
												fullWidth
											/>
										</Grid>
										<Grid item xs={12} md={2}>
											<TextField
												style={{ marginTop: 0, marginBottom: 0 }}
												value={tank.totalTankVolume}
												onChange={(event) => this.onChangeTank(event, i, 'totalTankVolume')}
												label="Total Volume"
												fullWidth
											/>
											<FormHelperText>(gallons)</FormHelperText>
										</Grid>
										<Grid item xs={12} md={2}>
											<TextField
												style={{ marginTop: 0, marginBottom: 0 }}
												value={tank.shutoffVolume}
												onChange={(event) => this.onChangeTank(event, i, 'shutoffVolume')}
												label="Shutoff Volume"
												fullWidth
											/>
											<FormHelperText>(gallons)</FormHelperText>
										</Grid>

										<Grid item xs={12} md={2}>
											<TextField
												style={{ marginTop: 0, marginBottom: 0 }}
												value={tank.resupplyVolume}
												onChange={(event) => this.onChangeTank(event, i, 'resupplyVolume')}
												label="Resupply Volume"
												fullWidth
											/>
											<FormHelperText>(gallons)</FormHelperText>
										</Grid>

										<Grid item xs={12} md={2}>
											<TextField
												style={{ marginTop: 0, marginBottom: 0 }}
												value={tank.tankType}
												onChange={(event) => this.onChangeTank(event, i, 'tankType')}
												label="Tank Type"
												fullWidth
											/>
										</Grid>
										<Grid item xs={12} md={1}>
											{!isExternalLogistics && (
												<IconButton
													color="primary"
													aria-label="Delete"
													onClick={() => this.removeTank(i)}
												>
													<DeleteIcon />
												</IconButton>
											)}
										</Grid>
									</Grid>
								);
							})}
						</Grid>

						{!isExternalLogistics && (
							<Grid item xs={12}>
								<Button
									variant="contained"
									className={classes.addInputButton}
									onClick={this.addTank}
								>
									ADD TANK
								</Button>
							</Grid>
						)}

						<Grid item xs={12}>
							<div className={classes.sectionHeader}>Helpers</div>
						</Grid>
						<FMPText
							{...this.getInputProps('deliveryNotes', '')}
							label={'Internal Delivery Notes'}
							multiline={4}
							md={8}
							helpText={
								'Note : NOT shared with carrier. Examples : Delivery only 5-10 AM, Always split with R024 Fontana, etc'
							}
							contained={false}
						/>

						<FMPText
							{...this.getInputProps('preferredDeliveryAmount')}
							label={'Preferred Delivery Amount'}
							helpText={'Note : If left blank amounts default to last delivered load'}
							contained={false}
						/>

						{!isExternalLogistics && this.renderInvoiceInfo()}

						<div style={{ textAlign: 'right' }}>
							<FMPSubmitButton
								onClick={this.onAddUpdateStation}
								buttonText={action}
								isDisabled={isExternalLogistics}
								disabledText={'Update permission is disabled'}
							/>

							{!!lastUpdatedByName && (
								<div style={{ padding: 10, fontSize: 14, color: '#888' }}>
									Last updated by {lastUpdatedByName}
									<br />
									on {lastUpdatedDisplay}
								</div>
							)}
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderPricingAndCosts = () => {
		const { classes, gasFormulas, rackFormulas, biodieselFormulas, authUser } = this.props;
		const { isUpdate } = this.state;

		let canUpdateFormula = false;
		if (!isUpdate) {
			canUpdateFormula = true;
		} else {
			canUpdateFormula = _.get(authUser, ['permissions', 'canMakeUpdateStationFormulas']);
		}

		const noneOptions = [
			{
				value: 0,
				display: 'Not sure yet',
			},
		];

		let showTripleFreight = true;
		let showPinnacleFreight = false;
		let showBiodieselFreight = false;

		const gasFormulaOptions = noneOptions.concat(
			gasFormulas.map((gasFormula) => {
				if (
					gasFormula.gasFormulaId === this.state.gasFormulaId &&
					(gasFormula.formulaKey === 'pinnaclePricing' ||
						gasFormula.formulaKey === 'pinnaclePricingNonContracted')
				) {
					showTripleFreight = false;
					showPinnacleFreight = true;
				}

				return {
					value: gasFormula.gasFormulaId,
					display: gasFormula.display,
				};
			})
		);

		const rackFormulaOptions = noneOptions.concat(
			rackFormulas.map((rackFormula) => {
				return {
					value: rackFormula.rackFormulaId,
					display: rackFormula.display,
				};
			})
		);

		const biodieselFormulaOptions = noneOptions.concat(
			biodieselFormulas.map((biodieselFormula) => {
				return {
					value: biodieselFormula.biodieselFormulaId,
					display: biodieselFormula.display,
				};
			})
		);

		const { gasFormulaId, rackFormulaId, biodieselFormulaId } = this.state;

		if (!gasFormulaId && !rackFormulaId && biodieselFormulaId) {
			showTripleFreight = false;
			showPinnacleFreight = false;
			showBiodieselFreight = true;
		}

		return (
			<>
				<FMPRegionHeader label={'Pricing & Costs'} />

				{!canUpdateFormula && (
					<Grid item xs={12} md={6}>
						<Note>Note: This account does not have the audit permission to change formulas.</Note>
					</Grid>
				)}

				<div className={classes.sectionHeader}>Formulas</div>
				<Grid item xs={12} md={6}>
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="rackFormula">Ethanol rack pricing formula</InputLabel>
						<Select
							value={this.state.rackFormulaId}
							onChange={(event) => this.handleSelectChange(event, 'rackFormulaId')}
							input={<Input id="rackFormula" />}
							disabled={!canUpdateFormula}
						>
							{rackFormulaOptions.map((rackFormula, i) => {
								return (
									<MenuItem key={i} value={rackFormula.value}>
										{rackFormula.display}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item xs={12} md={6}>
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="gasFormula">E85 pricing formula</InputLabel>
						<Select
							value={this.state.gasFormulaId}
							onChange={(event) => this.handleSelectChange(event, 'gasFormulaId')}
							input={<Input id="gasFormula" />}
							disabled={!canUpdateFormula}
						>
							{gasFormulaOptions.map((gasFormula, i) => {
								return (
									<MenuItem key={i} value={gasFormula.value}>
										{gasFormula.display}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item xs={12} md={6}>
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="biodieselFormula">Biodiesel formula</InputLabel>
						<Select
							value={this.state.biodieselFormulaId}
							onChange={(event) => this.handleSelectChange(event, 'biodieselFormulaId')}
							input={<Input id="biodieselFormula" />}
							disabled={!canUpdateFormula}
						>
							{biodieselFormulaOptions.map((biodieselFormula, i) => {
								return (
									<MenuItem key={i} value={biodieselFormula.value}>
										{biodieselFormula.display}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<div className={classes.sectionHeader}>Freight Costs</div>

				{showTripleFreight && (
					<div>
						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.freightFullLoad}
								onChange={(event) => this.onChangeName(event, 'freightFullLoad')}
								label="Full Load"
								fullWidth
							/>
						</Grid>

						{/*
						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.freightHalfLoadSplit}
								onChange={(event) => this.onChangeName(event, 'freightHalfLoadSplit')}
								label="Half load with split"
								fullWidth
							/>
						</Grid>

						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.freightHalfLoadNoSplit}
								onChange={(event) => this.onChangeName(event, 'freightHalfLoadNoSplit')}
								label="Half load unable to split"
								fullWidth
							/>
						</Grid>
						*/}
					</div>
				)}

				{showPinnacleFreight && (
					<div>
						<Grid item xs={12} md={6}>
							<TextField
								className={classes.formControl}
								value={this.state.pinnacleDeliveryAdder}
								onChange={(event) => this.onChangeName(event, 'pinnacleDeliveryAdder')}
								label="Pinnacle Delivery Adder"
								fullWidth
							/>
						</Grid>
					</div>
				)}

				{showBiodieselFreight && (
					<div>
						<Grid item xs={12} md={6}>
							<div className={classes.infoBox}>
								<InfoIcon className={classes.infoIcon} />
								<span>No freight for stations that are solely biodiesel.</span>
							</div>
						</Grid>
					</div>
				)}

				<div className={classes.sectionHeader}>Taxes</div>
				<Grid item xs={12} md={12}>
					<FMPText
						{...this.getInputProps('salesTax')}
						label={'Sales Tax (use decimal format, eg 0.0925)'}
						helpText={'Will default to 0.0925 if no value is entered.'}
					/>
				</Grid>
			</>
		);
	};

	renderInvoiceInfo = () => {
		const { classes, quickbooksCustomers } = this.props;

		const { invoiceQuickbooksCustomerId, requireUnlPriceOnInvoicing } = this.state;
		let selectedQuickbooksCustomer;

		const quickbooksCustomerOptions = _.sortBy(quickbooksCustomers, 'DisplayName').map(
			(quickbooksCustomer) => {
				const { quickbooksCustomerId, DisplayName, ParentRef } = quickbooksCustomer;

				let display = DisplayName;
				if (ParentRef) {
					display = <div style={{ paddingLeft: 20 }}>{DisplayName}</div>;
				}

				if (invoiceQuickbooksCustomerId === quickbooksCustomerId) {
					selectedQuickbooksCustomer = quickbooksCustomer;
				}

				return {
					value: quickbooksCustomerId,
					display,
				};
			}
		);

		return (
			<>
				<FMPRegionHeader label={'Invoice Info'} />
				<div className={classes.sectionHeader}>Link to Quickbooks</div>
				{_.isEmpty(quickbooksCustomerOptions) && <div>Still fetching quickbooks customers...</div>}
				{!_.isEmpty(quickbooksCustomerOptions) && (
					<FMPSelect
						label={`Quickbooks Customer`}
						path={['invoiceQuickbooksCustomerId']}
						controller={this}
						options={quickbooksCustomerOptions}
						onChange={(event) => this.handleSelectChange(event, 'invoiceQuickbooksCustomerId')}
						md={6}
					/>
				)}

				{!selectedQuickbooksCustomer && <div>Please select a valid quickbooks customer</div>}

				<div className={classes.sectionHeader}>Invoice Emails</div>
				{this.state.invoiceEmails.map((email, i) => {
					return (
						<Grid key={i} container spacing={3}>
							<FMPTextField
								name={'invoiceEmails'}
								index={i}
								label={`Email ${i + 1}`}
								controller={this}
								md={5}
								contained={false}
							/>
							<Grid item xs={1}>
								<IconButton
									color="primary"
									className={classes.button}
									onClick={() => this.removeInput('invoiceEmails', i)}
								>
									<DeleteIcon />
								</IconButton>
							</Grid>
						</Grid>
					);
				})}

				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('invoiceEmails')}
				>
					ADD INVOICE EMAIL
				</Button>

				<div className={classes.sectionHeader}>Invoice Options</div>
				<FMPSwitch
					key={`rup${requireUnlPriceOnInvoicing}`}
					label={'Require Unleaded Price on Invoicing'}
					value={requireUnlPriceOnInvoicing}
					path={'requireUnlPriceOnInvoicing'}
					onChange={this.onSwitchChange}
				/>

				<FMPText {...this.getInputProps('invoiceNotes')} label={'Invoice Notes'} multiline={2} />
			</>
		);
	};
}

SaveStation.propTypes = {
	authUser: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	searchGasFormulas: PropTypes.func.isRequired,
	searchRackFormulas: PropTypes.func.isRequired,
	searchBiodieselFormulas: PropTypes.func.isRequired,
	searchQuickbooksCustomers: PropTypes.func,
	quickbooksCustomers: PropTypes.array,
	gasFormulas: PropTypes.array,
	rackFormulas: PropTypes.array,
	biodieselFormulas: PropTypes.array,
	addStation: PropTypes.func.isRequired,
	updateStation: PropTypes.func.isRequired,
	station: PropTypes.object,
	getStation: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
	isExternalLogistics: PropTypes.bool.isRequired,
	userMap: PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	StationContainer,
	RackFormulas,
	GasFormulas,
	BiodieselFormulas,
	QuickbooksContainer,
	AuthUserContainer,
])(SaveStation);
